import { Grid, Modal, Checkbox, FormHelperText } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
  ModalCancelButton,
  ModalSubmitButton
} from '../parts/cloudStorage/style/style';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import { useForm, SubmitHandler } from 'react-hook-form';
import { TCopyTo, CopyModalAction } from '../../types/estimate/estimate';
import { useEffect } from 'react';
import { StyledSelect } from './Style';

type Inputs = {
  copyTo: TCopyTo;
  allCopy: boolean;
};

type Tprops = {
  copyToList: TCopyTo[];
  copyItem: any;
  copyModal: boolean;
  copyModalDispatch: React.Dispatch<CopyModalAction>;
};

export const CopyModal: React.FC<Tprops> = (props: Tprops) => {
  const {
    copyToList: copyToList,
    copyItem,
    copyModal,
    copyModalDispatch
  } = props;

  const classes = useStyles();

  // react-hook-form
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors }
  } = useForm<Inputs>({
    defaultValues: {
      allCopy: true
    }
  });
  const allCopy = watch('allCopy');
  const onSubmit: SubmitHandler<Inputs> = data => {
    copyModalDispatch({
      type: 'submit',
      copyTo: data.copyTo,
      copyItem,
      allCopy: data.allCopy
    });
  };

  // モーダルの開閉時に項目欄をセット
  useEffect(() => {
    // 第一階層の場合はバリデーションエラーがでないように初期値を設定
    if (copyItem.layer === 1) {
      reset({
        allCopy: true,
        copyTo: { location: [] }
      });
    } else {
      reset({
        allCopy: true,
        copyTo: undefined
      });
    }
  }, [copyModal, copyItem.layer, reset]);

  return (
    <Modal
      open={copyModal}
      onClose={() => copyModalDispatch({ type: 'close' })}
      aria-labelledby='simple-modal-title'
      aria-describedby='simple-modal-description'
      className={classes.container}
    >
      <Grid container className={classes.subpaper}>
        <Grid item xs={12}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid item xs={12}>
              <div style={{ textAlign: 'center', padding: 40, fontSize: 18 }}>
                <p>
                  第{copyItem.layer}階層の項目「{copyItem.name}」をコピー
                </p>
              </div>
              <div className={classes.formArea}>
                <div className={classes.inputArea}>
                  {copyItem.layer != 1 && (
                    <>
                      <div className={classes.labelText}>コピー先</div>
                      <FormControl variant='outlined' style={{ width: '100%' }}>
                        <StyledSelect
                          labelId='demo-simple-select-outlined-label'
                          id='demo-simple-select-outlined'
                          {...register('copyTo', {
                            required: 'コピー先を選択してください'
                          })}
                        >
                          {copyToList.map(copyTo => {
                            let location = copyTo.location;
                            let displayString = location
                              .slice(1)
                              .reduce(
                                (acc, value) =>
                                  acc + `　＞　${value.item.name}`,
                                `${location[0].item.name}`
                              );
                            return (
                              <MenuItem value={copyTo as any}>
                                {displayString}
                              </MenuItem>
                            );
                          })}
                        </StyledSelect>
                        {errors.copyTo && (
                          <FormHelperText className={classes.errorText}>
                            {errors.copyTo.message
                              ? String(errors.copyTo.message)
                              : ''}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </>
                  )}
                </div>
                <div className={classes.checkBoxText}>
                  {copyItem.hasUnderLayerFlg && (
                    <>
                      <Checkbox
                        {...register('allCopy')}
                        checked={allCopy}
                        color='default'
                      />
                      <div style={{ marginRight: 4 }}>下の階層をコピーする</div>
                    </>
                  )}
                </div>
              </div>
            </Grid>

            <Grid item xs={12} className={classes.modalFooter}>
              <ModalCancelButton
                variant='contained'
                onClick={() => {
                  copyModalDispatch({ type: 'close' });
                }}
              >
                キャンセル
              </ModalCancelButton>
              <ModalSubmitButton variant='contained' type='submit'>
                コピーする
              </ModalSubmitButton>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </Modal>
  );
};

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    modalHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column'
    },
    formArea: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      padding: '0 40px',
      marginBottom: 30
    },
    inputArea: {
      width: '100%',
      display: 'flex',
      alignItems: 'start',
      flexDirection: 'column',
      marginBottom: 30
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[5],
      width: '70%',
      overflow: 'hidden'
    },
    subpaper: {
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[5],
      width: '40%'
    },
    modalFooter: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderTop: '1px solid #cfcfcf',
      padding: 30
    },
    checkBoxText: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start'
    },
    labelText: {
      marginBottom: 12,
      fontSize: 12
    },
    errorText: {
      color: 'red'
    }
  })
);
